import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getCategories,
  getManufacturers,
} from "../inventory-item-create/item-create.component.service";
import { getInventoryItemsInputs } from "../model/inventory-item.modal";
import { menuUrl } from "../inventory-item-list/model/item-list.constants";
import InventoryItemEditTemplateComponent from "./item-edit-template.component";
import { editEntry } from "./item-edit.component.service";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ITEM_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const InventoryItemsEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");

  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
    loading: true,
  });
  const [formInputs, setFormInputs] = useState([]);

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    if (errors.length > 0) return;

    let payload = {};
    for (let i = 0; i < values.length; i++) {
      payload[values[i].name] = values[i].value;
    }

    setFormTriggers({ ...formTriggers, loading: true });

    const response = await editEntry(location?.state?.row?.id, payload);

    setFormTriggers({ ...formTriggers, loading: false });

    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  const onLoad = async () => {
    const categoryResponse = await getCategories();
    const manufacturerResponse = await getManufacturers();

    if (categoryResponse.status && manufacturerResponse.status) {
      const formattedCategories = categoryResponse.data?.map((cat) => ({
        name: cat.name,
        value: cat.id,
      }));

      const formattedManufacturers = manufacturerResponse.data.map((mfg) => ({
        name: mfg.manufacturer_name,
        value: mfg.manufacturer_name,
      }));
      console.log({ formattedCategories, formattedManufacturers });
      const initialValues = {
        category_id: location?.state?.row?.category_id || "",
        part_number: location?.state?.row?.part_number || "",
        manufacturer_name: location?.state?.row?.make || "",
        date_code: location?.state?.row?.date_code || "",
        source: location?.state?.row?.source || "",
        available_qty: location?.state?.row?.available_qty || "",
        lead_time: location?.state?.row?.lead_time || "",
        mpq: location?.state?.row?.mpq || "",
        image: location?.state?.row?.image || "",
        search_alias: location?.state?.row?.search_alias || "",
        status: location?.state?.row?.status || "",
        priceRepeater:
          location?.state?.row?.prices?.map((p) => ({
            slab: p.slab,
            price: p.price,
          })) || [],
        aliasRepeater:
          location?.state?.row?.aliases?.map((a) => ({
            search_alias: a.search_alias,
          })) || [],
      }
      console.log({ initialValues });

      const formInputData = getInventoryItemsInputs(
        formattedCategories,
        formattedManufacturers,
        initialValues,
      );

      setFormInputs(formInputData);
      setFormTriggers({ ...formTriggers, loading: false });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  return menuAccess ? (
    <InventoryItemEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default InventoryItemsEditComponent;
